import { BlueBeetlePageProps } from '../types/blueBeetlePageProps';
import Communicate from './LearnCommunicate/Communicate';
import Jumbotron from './Jumbotron';
import MarketingMessage from './MarketingMessage';
import LearnImmerseCommunicate from './LearnImmerseCommunicate';

type Props = Pick<BlueBeetlePageProps, 'membotScenario' | 'trailerScenario'>;

const BlueBeetlePageContent = ({ membotScenario, trailerScenario }: Props) => {
  return (
    <>
      <Jumbotron />
      <LearnImmerseCommunicate membotScenario={membotScenario} trailerScenario={trailerScenario} />
      <Communicate />
      <MarketingMessage />
    </>
  );
};

export default BlueBeetlePageContent;
